/**
 * Format Team Cup point values without hiding supported precision.
 *
 * Match values may carry three decimals and a halved match can therefore
 * produce a fourth decimal. Keep those meaningful digits while trimming
 * trailing zeroes from the presentation.
 */
export function formatTeamCupPoints(value: number, fallback = '0'): string {
  if (!Number.isFinite(value)) return fallback;
  const formatted = value.toFixed(4).replace(/\.?0+$/, '');
  return formatted === '-0' ? '0' : formatted;
}
